module.exports = __webpack_public_path__ + "img/4.19aae1c0.jpg";